import { render } from "./IDCardPrinting.vue?vue&type=template&id=c6e19678"
import script from "./IDCardPrinting.vue?vue&type=script&lang=js"
export * from "./IDCardPrinting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__